enum FeatureFlags {
  ConfLeadCapture = 'is_lead_capture_enabled',
  ConfLeadCaptureLicenseLimit = 'lead_capture_license_limit',
  ConfInteractiveMaps = 'is_interactive_maps_enabled',
  ConfVideoLibraryEnabled = 'is_video_library_enabled',
  HidePrePrintedBadges = 'hide_pre_printed_badges',
  OnsiteAppSessionRegistration = 'onsite_app_session_registration',
}

export default FeatureFlags;
